import React from 'react';
import PropTypes from 'prop-types';
import LibraryRichText from 'rich-text-to-react';
import { List, Paragraph, Typography } from '@telus-uds/components-web';
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types';

const defaultOptions = {
  [BLOCKS.HEADING_1]: (node, key, next) => (
    <Typography key={key} heading="h1" variant={{ size: 'h1' }} block>
      {next(node.content, key, next)}
    </Typography>
  ),
  [BLOCKS.HEADING_2]: (node, key, next) => (
    <Typography key={key} heading="h2" variant={{ size: 'h2' }} block>
      {next(node.content, key, next)}
    </Typography>
  ),
  [BLOCKS.HEADING_3]: (node, key, next) => (
    <Typography key={key} heading="h3" variant={{ size: 'h3' }} block>
      {next(node.content, key, next)}
    </Typography>
  ),
  [BLOCKS.HEADING_4]: (node, key, next) => (
    <Typography key={key} heading="h4" variant={{ size: 'h4' }} block>
      {next(node.content, key, next)}
    </Typography>
  ),
  [BLOCKS.HEADING_5]: (node, key, next) => (
    <Typography key={key} heading="h5" variant={{ size: 'h5' }} block>
      {next(node.content, key, next)}
    </Typography>
  ),
  [BLOCKS.HEADING_6]: (node, key, next) => (
    <h6
      style={{
        color: '#49166d'
      }}
    >
      {next(node.content, key, next)}
    </h6>
  ),
  [BLOCKS.PARAGRAPH]: (node, key, next) => (
    <Paragraph key={key} style={{ lineHeight: '1.5rem', marginBottom: '1em' }}>
      {next(node.content, key, next)}
    </Paragraph>
  ),
  [BLOCKS.UL_LIST]: (node, key, next) => (
    <List key={key}>{next(node.content, key, next)}</List>
  ),
  [BLOCKS.LIST_ITEM]: (node, key, next) => (
    <List.Item key={key}>
      {next(node.content, key, next)}
    </List.Item>
  ),
  [INLINES.HYPERLINK]: (node, key, next) => {
    const { uri } = node.data;
    return (
      <a key={key} href={uri} target="_blank" rel="noopener noreferrer">
        {next(node.content, key, next)}
      </a>
    );
  },
  [BLOCKS.EMBEDDED_ASSET]: node => {
    return (
      <>
        <img
          alt={node.data.target.fields.file.title}
          className="img-fluid"
          width={250}
          src={node.data.target.fields.file.url}
        />
      </>
    );
  }
};

const RichText = ({ data = null, options: { renderMark = {}, renderNode = {} } = {} }) => {
  const mergedOptions = {
    renderMark: {
      ...renderMark,
      [MARKS.BOLD]: (text, key) => (
        <strong key={key} style={{ fontWeight: '900' }}>
          {text}
        </strong>
      )
    },
    renderNode: {
      ...defaultOptions,
      ...renderNode
    }
  };

  return data && <LibraryRichText document={data} options={mergedOptions} />;
};

RichText.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object)
  }),
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  })
};

export default RichText;
